/**
 * Whether receipt history may be loaded from the local SQLite catalog
 * without a live access token (Electron offline session).
 */
export function canLoadLocalReceiptHistory(opts: {
  accessToken: string;
  usesLocalCatalog: boolean;
}): boolean {
  if (opts.usesLocalCatalog) return true;
  return Boolean(opts.accessToken);
}

/**
 * Whether a receipt lookup may proceed against local history without a token.
 * Empty receipt id is always rejected by the caller.
 */
export function canLookupLocalReceipt(opts: {
  accessToken: string;
  usesLocalCatalog: boolean;
  receiptId: string;
}): { ok: boolean; reason?: 'empty_id' | 'needs_token' } {
  if (!opts.receiptId.trim()) {
    return { ok: false, reason: 'empty_id' };
  }
  if (opts.usesLocalCatalog) {
    return { ok: true };
  }
  if (!opts.accessToken) {
    return { ok: false, reason: 'needs_token' };
  }
  return { ok: true };
}

/** Online pull of history from BE requires a token even on Electron. */
export function canPullRemoteReceiptHistory(opts: {
  accessToken: string;
  usesLocalCatalog: boolean;
  isOnline: boolean;
}): boolean {
  return Boolean(opts.accessToken) && opts.usesLocalCatalog && opts.isOnline;
}
